<template>
  <v-container class="d-flex justify-center align-center flex-column" >
    <v-progress-circular class="ma-5" :indeterminate="true" />
    <div class="text-center">
      Thanks for subscribing!  Give us a couple seconds to process your subscription.
    </div>
  </v-container>
</template>

<script>
import StoreConstants from "@/store/StoreConstants";
import Utils from "@/services/Utils";

export default {
  name: "JustSubscribed",
  mounted() {

    const init = async () => {
      await Utils.sleep(2000)
      for(let c = 0; c < 60; c++) {
        console.log('checking for sub')
        await this.$store.dispatch(StoreConstants.actions.loadAccount)
        if(this.$store.state.account && this.$store.state.account.subscribed) {
          break
        } else {
          await Utils.sleep(2500 + c / 5 * 1000)
        }
      }
      await this.$router.replace('home')
    }

    init()
  }
}
</script>

<style scoped>

</style>